module.exports = __webpack_public_path__ + "media/csca-knot.004ce2a8.mp4";